import styled from "styled-components";

export const StyledCashFlowProfitWrapper = styled.div``;

export const StyledCashFlowProfitListItem = styled.div`
  border-top: 1px solid ${({theme}) => theme.surface.border};
  &:last-child {
    border-bottom: 1px solid ${({theme}) => theme.surface.border};
  }
  
  .profit-list-table {
    &__row {
      border: none;
    }
  }
  .active {
    color: ${({theme}) => theme.brand.primary};
    background-color: ${({theme}) => theme.surface.hover};
    border-bottom: 1px solid ${({theme}) => theme.surface.border};
  }
`;

export const StyledCashFlowProfitDetailsWrapper = styled.div`
  margin-left: 40px;
  border-left: 1px solid ${({theme}) => theme.surface.border};

  .service-profit-table {
    margin-bottom: 0;
    &__head, &__row {
      padding: 20px;
      grid-template-columns: minmax(0, 350px) 1fr;
    }
    &__row {
      &:last-child {
        border-bottom: none;
      }
    }
  }
`;

export const StyledAboutOfProfit = styled.div`
  padding: 2px 8px;
  color: ${({ color, theme }) => color === "green" ? theme.badge.successColor : color === "red" ? theme.badge.dangerColor : theme.badge.neutralColor};
  font-weight: 600;
  background-color: ${({ color, theme }) => color === "green" ? theme.badge.successBackground : color === "red" ? theme.badge.dangerBackground : theme.badge.neutralBackground};
  border-radius: 5px;
`;